import { jsx as _jsx } from "react/jsx-runtime";
import Image from "next/legacy/image";
import { storyblokImageLoader } from "@cinch-nx/data-storyblok";
import styles from "./hero-image.module.css";
import cx from "classnames";
export function HeroImage({ isMobileImageShown , image  }) {
    return /*#__PURE__*/ _jsx("div", {
        className: cx(styles["imageContainer"], {
            [styles["isShownOnMobile"]]: isMobileImageShown
        }),
        children: /*#__PURE__*/ _jsx(Image, {
            src: image.filename,
            alt: image.alt ?? "Hero Image",
            loader: storyblokImageLoader,
            priority: true,
            layout: "intrinsic",
            width: 700,
            height: 240
        })
    });
}
